// import React, { useEffect, useState } from "react";
// import { handleError } from "../../utils/helpers";

// const useGetAllUsers = (filters, search, limit) => {
//   const [users, setUsers] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const dummyData = [
//     {
//       id: 1,
//       name: "Samuel Fischer",
//       email: "alvarezaustin@andrews.com",
//       role: "manager",
//       status: "active",
//       createdAt: "2024-10-03T22:22:04Z",
//       lastLogin: "2024-10-04T22:22:04Z",
//       totalTransactions: 0,
//       totalSpent: 1322.76,
//       avatar: null,
//       phone: "+13328706327",
//       address: "3465 Davies Square Apt. 945, North Staceyside, HI 70208",
//       isBlocked: true,
//     },
//     {
//       id: 2,
//       name: "Tina Brown",
//       email: "glawrence@brown.net",
//       role: "user",
//       status: "active",
//       createdAt: "2025-03-03T10:09:33Z",
//       lastLogin: "2025-04-02T10:09:33Z",
//       totalTransactions: 26,
//       totalSpent: 6577.77,
//       avatar: null,
//       phone: "+19004161801",
//       address: "84183 Ballard Hollow, Loganland, VT 86148",
//       isBlocked: true,
//     },
//     {
//       id: 3,
//       name: "Kimberly Davis",
//       email: "mlamb@coleman.com",
//       role: "admin",
//       status: "inactive",
//       createdAt: "2025-05-21T12:33:43Z",
//       lastLogin: "2025-06-16T12:33:43Z",
//       totalTransactions: 19,
//       totalSpent: 6689.87,
//       avatar: null,
//       phone: "+18033038252",
//       address: "9634 Michelle Glens Apt. 688, West Samuelberg, IL 77422",
//       isBlocked: true,
//     },
//     {
//       id: 4,
//       name: "Carol Hale",
//       email: "conwayanthony@hotmail.com",
//       role: "admin",
//       status: "inactive",
//       createdAt: "2025-02-14T16:18:31Z",
//       lastLogin: "2025-02-21T16:18:31Z",
//       totalTransactions: 47,
//       totalSpent: 9962.18,
//       avatar: null,
//       phone: "+17511103326",
//       address: "07798 Spencer Crest, Micheleborough, MO 50188",
//       isBlocked: false,
//     },
//     {
//       id: 5,
//       name: "Donna Wilkins",
//       email: "browningkevin@thomas.biz",
//       role: "admin",
//       status: "active",
//       createdAt: "2025-08-03T12:43:08Z",
//       lastLogin: "2025-08-23T12:43:08Z",
//       totalTransactions: 44,
//       totalSpent: 2366.46,
//       avatar: null,
//       phone: "+14741240846",
//       address: "Unit 8597 Box 1144, DPO AE 87240",
//       isBlocked: true,
//     },
//     {
//       id: 6,
//       name: "Megan Torres",
//       email: "chapmanalex@hotmail.com",
//       role: "user",
//       status: "inactive",
//       createdAt: "2025-07-30T23:07:00Z",
//       lastLogin: "2025-08-01T23:07:00Z",
//       totalTransactions: 21,
//       totalSpent: 2884.65,
//       avatar: null,
//       phone: "+14448355204",
//       address: "8788 Vazquez Green Apt. 082, Padillabury, MT 95544",
//       isBlocked: false,
//     },
//     {
//       id: 7,
//       name: "Devin Jones",
//       email: "krodriguez@gmail.com",
//       role: "user",
//       status: "inactive",
//       createdAt: "2025-05-06T20:26:53Z",
//       lastLogin: "2025-05-26T20:26:53Z",
//       totalTransactions: 27,
//       totalSpent: 1414.95,
//       avatar: null,
//       phone: "+15644604301",
//       address: "060 Brittany Rest Apt. 036, South Dorothy, NH 21245",
//       isBlocked: true,
//     },
//     {
//       id: 8,
//       name: "Kimberly Kelly",
//       email: "kelly46@yahoo.com",
//       role: "user",
//       status: "active",
//       createdAt: "2025-08-08T22:02:32Z",
//       lastLogin: "2025-09-04T22:02:32Z",
//       totalTransactions: 50,
//       totalSpent: 1720.39,
//       avatar: null,
//       phone: "+15414228996",
//       address: "1825 Miller Parkways, Michaelport, TN 76832",
//       isBlocked: true,
//     },
//     {
//       id: 9,
//       name: "David Ryan",
//       email: "amber44@bonilla.net",
//       role: "user",
//       status: "inactive",
//       createdAt: "2024-08-30T19:22:20Z",
//       lastLogin: "2024-09-19T19:22:20Z",
//       totalTransactions: 35,
//       totalSpent: 8110.22,
//       avatar: null,
//       phone: "+12478474258",
//       address: "499 Williams Plains, Lake Alexandra, HI 30608",
//       isBlocked: true,
//     },
//     {
//       id: 10,
//       name: "Selena Myers",
//       email: "itran@wade-davis.net",
//       role: "admin",
//       status: "active",
//       createdAt: "2024-10-23T23:52:46Z",
//       lastLogin: "2024-11-18T23:52:46Z",
//       totalTransactions: 12,
//       totalSpent: 4173.71,
//       avatar: null,
//       phone: "+13749977510",
//       address: "32038 Darlene Lodge, Stevenport, IN 71060",
//       isBlocked: false,
//     },
//     {
//       id: 11,
//       name: "Ellen Miller",
//       email: "diazandrew@yahoo.com",
//       role: "user",
//       status: "inactive",
//       createdAt: "2025-04-20T08:01:15Z",
//       lastLogin: "2025-05-06T08:01:15Z",
//       totalTransactions: 42,
//       totalSpent: 5300.85,
//       avatar: null,
//       phone: "+13757833846",
//       address: "67718 Leah Glens, North Katherine, ME 40541",
//       isBlocked: true,
//     },
//     {
//       id: 12,
//       name: "Emily Day",
//       email: "fsantos@gates.com",
//       role: "manager",
//       status: "active",
//       createdAt: "2024-09-01T13:58:13Z",
//       lastLogin: "2024-09-10T13:58:13Z",
//       totalTransactions: 4,
//       totalSpent: 9751.15,
//       avatar: null,
//       phone: "+19400842444",
//       address: "32621 Singh Hill, Kimberlyton, MN 06375",
//       isBlocked: false,
//     },
//     {
//       id: 13,
//       name: "Laurie Duarte",
//       email: "bartlettapril@gallegos.com",
//       role: "user",
//       status: "active",
//       createdAt: "2025-02-21T08:51:09Z",
//       lastLogin: "2025-03-06T08:51:09Z",
//       totalTransactions: 6,
//       totalSpent: 2854.34,
//       avatar: null,
//       phone: "+18102228418",
//       address: "9039 Carol Islands, Lake Latoyaport, NC 93671",
//       isBlocked: true,
//     },
//     {
//       id: 14,
//       name: "Edward Costa",
//       email: "williamsmorgan@howard.com",
//       role: "manager",
//       status: "active",
//       createdAt: "2025-04-08T00:47:11Z",
//       lastLogin: "2025-04-30T00:47:11Z",
//       totalTransactions: 15,
//       totalSpent: 6273.93,
//       avatar: null,
//       phone: "+19523611366",
//       address: "7668 Betty Isle, Coletown, AZ 55837",
//       isBlocked: true,
//     },
//     {
//       id: 15,
//       name: "Jason Kelly",
//       email: "leerobert@robinson.com",
//       role: "manager",
//       status: "inactive",
//       createdAt: "2025-04-16T00:59:39Z",
//       lastLogin: "2025-05-12T00:59:39Z",
//       totalTransactions: 7,
//       totalSpent: 3085.55,
//       avatar: null,
//       phone: "+15710831336",
//       address: "940 Miller Club Suite 813, Shermanborough, TX 42814",
//       isBlocked: true,
//     },
//     {
//       id: 16,
//       name: "David Taylor",
//       email: "alisha39@gmail.com",
//       role: "user",
//       status: "active",
//       createdAt: "2024-08-14T11:21:01Z",
//       lastLogin: "2024-08-26T11:21:01Z",
//       totalTransactions: 15,
//       totalSpent: 4879.32,
//       avatar: null,
//       phone: "+11525870484",
//       address: "61961 Amanda Common Suite 256, East Davidmouth, NV 96919",
//       isBlocked: false,
//     },
//     {
//       id: 17,
//       name: "Brooke Johnson",
//       email: "uwoodard@hernandez.net",
//       role: "admin",
//       status: "inactive",
//       createdAt: "2025-06-22T18:44:24Z",
//       lastLogin: "2025-07-11T18:44:24Z",
//       totalTransactions: 17,
//       totalSpent: 6112.02,
//       avatar: null,
//       phone: "+12437446998",
//       address: "16584 Shawn Harbors, Watsonland, WI 21247",
//       isBlocked: false,
//     },
//     {
//       id: 18,
//       name: "Heather Munoz",
//       email: "uriley@brooks.org",
//       role: "manager",
//       status: "inactive",
//       createdAt: "2025-02-26T13:18:49Z",
//       lastLogin: "2025-03-28T13:18:49Z",
//       totalTransactions: 36,
//       totalSpent: 8354.65,
//       avatar: null,
//       phone: "+18431643812",
//       address: "USNS Martinez, FPO AE 26708",
//       isBlocked: false,
//     },
//     {
//       id: 19,
//       name: "Robert White",
//       email: "parkerrobert@yahoo.com",
//       role: "user",
//       status: "active",
//       createdAt: "2024-11-25T21:00:50Z",
//       lastLogin: "2024-12-16T21:00:50Z",
//       totalTransactions: 27,
//       totalSpent: 138.73,
//       avatar: null,
//       phone: "+14257631020",
//       address: "8182 Williams Station Suite 095, Amandaberg, NE 21936",
//       isBlocked: true,
//     },
//     {
//       id: 20,
//       name: "Christopher Silva",
//       email: "lopezautumn@forbes-white.info",
//       role: "admin",
//       status: "inactive",
//       createdAt: "2025-06-15T10:08:37Z",
//       lastLogin: "2025-06-20T10:08:37Z",
//       totalTransactions: 14,
//       totalSpent: 8441.73,
//       avatar: null,
//       phone: "+13940712337",
//       address: "354 Morgan Stream Apt. 716, Williamville, TN 11966",
//       isBlocked: false,
//     },
//     {
//       id: 21,
//       name: "Tony Lane",
//       email: "patricia53@hotmail.com",
//       role: "manager",
//       status: "inactive",
//       createdAt: "2024-12-31T03:32:27Z",
//       lastLogin: "2025-01-29T03:32:27Z",
//       totalTransactions: 11,
//       totalSpent: 5314.1,
//       avatar: null,
//       phone: "+16209582632",
//       address: "05023 Jennifer Passage Suite 531, Haleberg, CO 30428",
//       isBlocked: true,
//     },
//     {
//       id: 22,
//       name: "Tonya Jordan",
//       email: "dunlapsandra@yahoo.com",
//       role: "manager",
//       status: "inactive",
//       createdAt: "2025-05-25T10:25:38Z",
//       lastLogin: "2025-06-21T10:25:38Z",
//       totalTransactions: 4,
//       totalSpent: 6182.39,
//       avatar: null,
//       phone: "+14982202779",
//       address: "0060 Teresa Trace Suite 003, Lake Ericville, NC 77498",
//       isBlocked: false,
//     },
//     {
//       id: 23,
//       name: "Ruben Pham",
//       email: "christinemoore@hotmail.com",
//       role: "admin",
//       status: "inactive",
//       createdAt: "2024-08-28T09:50:57Z",
//       lastLogin: "2024-09-21T09:50:57Z",
//       totalTransactions: 46,
//       totalSpent: 6916.53,
//       avatar: null,
//       phone: "+15357476797",
//       address: "197 Gregory Ville, Lake Thomas, MO 23767",
//       isBlocked: false,
//     },
//     {
//       id: 24,
//       name: "Amanda Estrada",
//       email: "tanderson@cardenas.com",
//       role: "user",
//       status: "active",
//       createdAt: "2024-10-04T19:53:17Z",
//       lastLogin: "2024-10-15T19:53:17Z",
//       totalTransactions: 29,
//       totalSpent: 9341.56,
//       avatar: null,
//       phone: "+19596520383",
//       address: "48926 Latoya Stream, New Paul, IL 09762",
//       isBlocked: true,
//     },
//     {
//       id: 25,
//       name: "Laura Richardson",
//       email: "andrew26@thompson-velazquez.biz",
//       role: "user",
//       status: "active",
//       createdAt: "2024-10-05T21:01:28Z",
//       lastLogin: "2024-11-02T21:01:28Z",
//       totalTransactions: 28,
//       totalSpent: 2035.49,
//       avatar: null,
//       phone: "+15157395387",
//       address: "227 Paul Spring Suite 436, Lake Jeffreyland, AK 40341",
//       isBlocked: false,
//     },
//     {
//       id: 26,
//       name: "Breanna Macias",
//       email: "jamesjesse@yahoo.com",
//       role: "user",
//       status: "active",
//       createdAt: "2025-03-09T01:31:57Z",
//       lastLogin: "2025-03-22T01:31:57Z",
//       totalTransactions: 11,
//       totalSpent: 7532.28,
//       avatar: null,
//       phone: "+17806010282",
//       address: "USNS Alvarez, FPO AE 93236",
//       isBlocked: true,
//     },
//     {
//       id: 27,
//       name: "Kristie Wells",
//       email: "stewartluke@hotmail.com",
//       role: "admin",
//       status: "active",
//       createdAt: "2024-08-21T09:25:46Z",
//       lastLogin: "2024-08-27T09:25:46Z",
//       totalTransactions: 48,
//       totalSpent: 4232.59,
//       avatar: null,
//       phone: "+13353506042",
//       address: "8504 Beck Orchard, Liport, WA 18754",
//       isBlocked: false,
//     },
//     {
//       id: 28,
//       name: "Alexander Barrett",
//       email: "travisrasmussen@hotmail.com",
//       role: "manager",
//       status: "inactive",
//       createdAt: "2025-02-02T06:18:09Z",
//       lastLogin: "2025-02-18T06:18:09Z",
//       totalTransactions: 19,
//       totalSpent: 6321.8,
//       avatar: null,
//       phone: "+16536062246",
//       address: "303 Compton Ville, East Ginabury, OR 30813",
//       isBlocked: false,
//     },
//     {
//       id: 29,
//       name: "Trevor Smith",
//       email: "kinggeorge@yahoo.com",
//       role: "manager",
//       status: "inactive",
//       createdAt: "2024-11-14T13:51:05Z",
//       lastLogin: "2024-11-15T13:51:05Z",
//       totalTransactions: 25,
//       totalSpent: 3245.67,
//       avatar: null,
//       phone: "+19340256540",
//       address: "6968 Dalton Burg Suite 286, Kristinstad, ND 33004",
//       isBlocked: false,
//     },
//     {
//       id: 30,
//       name: "Martha Davis",
//       email: "tmorales@harper.com",
//       role: "user",
//       status: "inactive",
//       createdAt: "2025-05-24T07:20:51Z",
//       lastLogin: "2025-06-04T07:20:51Z",
//       totalTransactions: 17,
//       totalSpent: 8733.79,
//       avatar: null,
//       phone: "+15754037550",
//       address: "6908 Kathleen Villages Suite 489, Lake Phillip, ID 37886",
//       isBlocked: true,
//     },
//     {
//       id: 31,
//       name: "Daniel Reid",
//       email: "blairmichael@rodriguez-anderson.info",
//       role: "admin",
//       status: "inactive",
//       createdAt: "2025-04-10T21:14:42Z",
//       lastLogin: "2025-04-21T21:14:42Z",
//       totalTransactions: 20,
//       totalSpent: 1568.26,
//       avatar: null,
//       phone: "+11474633680",
//       address: "05704 Day Knoll Apt. 156, Lake Stephenland, NE 04442",
//       isBlocked: true,
//     },
//     {
//       id: 32,
//       name: "James Smith",
//       email: "rmolina@harris-hudson.com",
//       role: "admin",
//       status: "inactive",
//       createdAt: "2024-11-27T23:06:56Z",
//       lastLogin: "2024-12-10T23:06:56Z",
//       totalTransactions: 0,
//       totalSpent: 819.48,
//       avatar: null,
//       phone: "+12168623983",
//       address: "56957 Duarte Walks, Rachelland, NV 80592",
//       isBlocked: false,
//     },
//     {
//       id: 33,
//       name: "Benjamin Krueger",
//       email: "zboone@yahoo.com",
//       role: "user",
//       status: "active",
//       createdAt: "2025-04-22T17:25:42Z",
//       lastLogin: "2025-05-13T17:25:42Z",
//       totalTransactions: 34,
//       totalSpent: 9443.26,
//       avatar: null,
//       phone: "+16766419589",
//       address: "989 Jeff Cliff Suite 057, East Toni, MN 13402",
//       isBlocked: false,
//     },
//     {
//       id: 34,
//       name: "Donald Morgan",
//       email: "kbryant@yahoo.com",
//       role: "admin",
//       status: "active",
//       createdAt: "2024-12-03T15:27:19Z",
//       lastLogin: "2024-12-17T15:27:19Z",
//       totalTransactions: 48,
//       totalSpent: 5505.19,
//       avatar: null,
//       phone: "+11980157109",
//       address: "5909 Daniel Inlet Suite 121, Acevedoberg, PA 21789",
//       isBlocked: true,
//     },
//     {
//       id: 35,
//       name: "Gregory Woods",
//       email: "williamwu@hotmail.com",
//       role: "admin",
//       status: "active",
//       createdAt: "2025-07-30T23:23:42Z",
//       lastLogin: "2025-08-19T23:23:42Z",
//       totalTransactions: 9,
//       totalSpent: 4563.46,
//       avatar: null,
//       phone: "+17585480011",
//       address: "88876 Kathryn Bypass, South Christinafort, VT 38769",
//       isBlocked: false,
//     },
//     {
//       id: 36,
//       name: "Lauren Torres",
//       email: "vazquezjay@hess-whitney.com",
//       role: "admin",
//       status: "inactive",
//       createdAt: "2024-11-24T16:49:54Z",
//       lastLogin: "2024-12-11T16:49:54Z",
//       totalTransactions: 24,
//       totalSpent: 7163.85,
//       avatar: null,
//       phone: "+13483961932",
//       address: "101 Hill Views Suite 111, West Kevin, WV 13750",
//       isBlocked: true,
//     },
//     {
//       id: 37,
//       name: "Nicole Patel",
//       email: "bryan56@vaughn.org",
//       role: "user",
//       status: "inactive",
//       createdAt: "2024-12-30T13:19:09Z",
//       lastLogin: "2025-01-17T13:19:09Z",
//       totalTransactions: 28,
//       totalSpent: 4952.3,
//       avatar: null,
//       phone: "+14578243009",
//       address: "092 Stone Coves Apt. 886, North Jasonborough, WA 96254",
//       isBlocked: true,
//     },
//     {
//       id: 38,
//       name: "Michael Acosta",
//       email: "richardskevin@hotmail.com",
//       role: "admin",
//       status: "inactive",
//       createdAt: "2024-08-14T17:25:25Z",
//       lastLogin: "2024-08-15T17:25:25Z",
//       totalTransactions: 4,
//       totalSpent: 4205.11,
//       avatar: null,
//       phone: "+13510153536",
//       address: "2479 Kevin Loop Suite 717, Kleinchester, PA 35396",
//       isBlocked: false,
//     },
//     {
//       id: 39,
//       name: "Pamela Davis",
//       email: "jilliandixon@yahoo.com",
//       role: "admin",
//       status: "active",
//       createdAt: "2025-05-22T08:39:21Z",
//       lastLogin: "2025-06-09T08:39:21Z",
//       totalTransactions: 27,
//       totalSpent: 856.76,
//       avatar: null,
//       phone: "+11693562314",
//       address: "2316 Maurice Lights Apt. 980, Brianhaven, AZ 23724",
//       isBlocked: false,
//     },
//     {
//       id: 40,
//       name: "Christina Davis",
//       email: "bowmanjason@moreno-norton.com",
//       role: "manager",
//       status: "active",
//       createdAt: "2025-06-05T20:49:38Z",
//       lastLogin: "2025-06-24T20:49:38Z",
//       totalTransactions: 48,
//       totalSpent: 7429.62,
//       avatar: null,
//       phone: "+13864665394",
//       address: "4432 Quinn Shoal, Patrickmouth, AK 92288",
//       isBlocked: true,
//     },
//     {
//       id: 41,
//       name: "Hannah Mason",
//       email: "darrencalderon@hernandez.com",
//       role: "user",
//       status: "inactive",
//       createdAt: "2024-12-30T14:16:32Z",
//       lastLogin: "2025-01-26T14:16:32Z",
//       totalTransactions: 18,
//       totalSpent: 3423.74,
//       avatar: null,
//       phone: "+16214851065",
//       address: "936 Jessica Ports Apt. 651, Port Stephanie, WV 94385",
//       isBlocked: true,
//     },
//     {
//       id: 42,
//       name: "Vickie Diaz",
//       email: "sarahnicholson@gmail.com",
//       role: "user",
//       status: "active",
//       createdAt: "2025-01-04T02:42:27Z",
//       lastLogin: "2025-01-23T02:42:27Z",
//       totalTransactions: 34,
//       totalSpent: 9342.6,
//       avatar: null,
//       phone: "+17911610591",
//       address: "7166 Hunter Circle Suite 350, Leslieburgh, NY 75414",
//       isBlocked: true,
//     },
//     {
//       id: 43,
//       name: "Dr. Xavier Bennett",
//       email: "alexander21@webb-patrick.com",
//       role: "admin",
//       status: "active",
//       createdAt: "2024-08-26T00:55:58Z",
//       lastLogin: "2024-08-29T00:55:58Z",
//       totalTransactions: 21,
//       totalSpent: 564.93,
//       avatar: null,
//       phone: "+13057375019",
//       address: "453 Robbins Lakes Suite 533, Port Dawn, DE 37480",
//       isBlocked: false,
//     },
//     {
//       id: 44,
//       name: "Justin Grant",
//       email: "brian46@yahoo.com",
//       role: "admin",
//       status: "active",
//       createdAt: "2025-04-27T10:10:49Z",
//       lastLogin: "2025-05-14T10:10:49Z",
//       totalTransactions: 27,
//       totalSpent: 641.55,
//       avatar: null,
//       phone: "+11633058859",
//       address: "30571 Steven Fall Apt. 386, Nicolefurt, ID 74529",
//       isBlocked: true,
//     },
//     {
//       id: 45,
//       name: "Michael Powers",
//       email: "jadeyang@bush.com",
//       role: "manager",
//       status: "inactive",
//       createdAt: "2025-01-05T20:25:17Z",
//       lastLogin: "2025-01-23T20:25:17Z",
//       totalTransactions: 39,
//       totalSpent: 8711.85,
//       avatar: null,
//       phone: "+11618902352",
//       address: "1423 Trevino Springs Apt. 320, New Rachelland, RI 88631",
//       isBlocked: true,
//     },
//     {
//       id: 46,
//       name: "Jose Knight",
//       email: "holly42@terrell-carter.com",
//       role: "user",
//       status: "active",
//       createdAt: "2025-05-08T11:26:24Z",
//       lastLogin: "2025-05-21T11:26:24Z",
//       totalTransactions: 42,
//       totalSpent: 6278.65,
//       avatar: null,
//       phone: "+16564654747",
//       address: "310 Margaret Lodge, Lisafurt, NE 31803",
//       isBlocked: false,
//     },
//     {
//       id: 47,
//       name: "Hector Webb",
//       email: "baileymatthew@yahoo.com",
//       role: "user",
//       status: "active",
//       createdAt: "2024-08-25T00:20:15Z",
//       lastLogin: "2024-09-08T00:20:15Z",
//       totalTransactions: 19,
//       totalSpent: 152.48,
//       avatar: null,
//       phone: "+12494935415",
//       address: "562 Judith Ports, Charlesmouth, NC 95553",
//       isBlocked: true,
//     },
//     {
//       id: 48,
//       name: "Billy Yu",
//       email: "qknapp@wiley.info",
//       role: "admin",
//       status: "inactive",
//       createdAt: "2024-11-23T16:36:34Z",
//       lastLogin: "2024-12-18T16:36:34Z",
//       totalTransactions: 17,
//       totalSpent: 5480.68,
//       avatar: null,
//       phone: "+11072708726",
//       address: "55770 David Mountains Suite 506, Hatfieldside, VA 39735",
//       isBlocked: true,
//     },
//     {
//       id: 49,
//       name: "Andrea Ward",
//       email: "raymondcastillo@gmail.com",
//       role: "admin",
//       status: "inactive",
//       createdAt: "2024-11-24T09:32:38Z",
//       lastLogin: "2024-12-11T09:32:38Z",
//       totalTransactions: 11,
//       totalSpent: 8051.47,
//       avatar: null,
//       phone: "+16183467536",
//       address: "227 Stephanie Club Suite 868, Mcgeehaven, WA 88154",
//       isBlocked: false,
//     },
//     {
//       id: 50,
//       name: "Andrew Hurley",
//       email: "austinsmith@anthony-barrett.org",
//       role: "admin",
//       status: "inactive",
//       createdAt: "2025-01-10T10:14:01Z",
//       lastLogin: "2025-01-31T10:14:01Z",
//       totalTransactions: 39,
//       totalSpent: 1782.07,
//       avatar: null,
//       phone: "+13073749558",
//       address: "677 Archer Road, Milesville, IN 04066",
//       isBlocked: true,
//     },
//     {
//       id: 51,
//       name: "Kimberly Sosa",
//       email: "wrubio@wilson.com",
//       role: "user",
//       status: "active",
//       createdAt: "2025-06-08T13:06:52Z",
//       lastLogin: "2025-06-19T13:06:52Z",
//       totalTransactions: 29,
//       totalSpent: 6618.39,
//       avatar: null,
//       phone: "+14327777566",
//       address: "4595 Deborah Row, Lake Lindsey, WY 81688",
//       isBlocked: true,
//     },
//     {
//       id: 52,
//       name: "Robert Butler",
//       email: "houstoneric@lewis-rivera.net",
//       role: "admin",
//       status: "active",
//       createdAt: "2025-06-22T11:17:18Z",
//       lastLogin: "2025-07-03T11:17:18Z",
//       totalTransactions: 15,
//       totalSpent: 1507.03,
//       avatar: null,
//       phone: "+18240565667",
//       address: "53208 Williams Branch, Rodriguezmouth, HI 30188",
//       isBlocked: false,
//     },
//     {
//       id: 53,
//       name: "Brittany Sanders",
//       email: "lewisjenna@brown-perez.biz",
//       role: "manager",
//       status: "active",
//       createdAt: "2025-06-18T15:18:08Z",
//       lastLogin: "2025-06-23T15:18:08Z",
//       totalTransactions: 35,
//       totalSpent: 3754.74,
//       avatar: null,
//       phone: "+14759412607",
//       address: "48110 Adam Port Suite 627, North Brentville, HI 41074",
//       isBlocked: true,
//     },
//     {
//       id: 54,
//       name: "Vanessa Smith",
//       email: "tony15@johns.com",
//       role: "manager",
//       status: "active",
//       createdAt: "2025-08-04T13:38:22Z",
//       lastLogin: "2025-08-11T13:38:22Z",
//       totalTransactions: 25,
//       totalSpent: 2078.67,
//       avatar: null,
//       phone: "+18814360863",
//       address: "PSC 4198, Box 9397, APO AE 47191",
//       isBlocked: false,
//     },
//     {
//       id: 55,
//       name: "Megan Ross",
//       email: "kcombs@hotmail.com",
//       role: "user",
//       status: "active",
//       createdAt: "2024-12-22T18:18:19Z",
//       lastLogin: "2025-01-06T18:18:19Z",
//       totalTransactions: 31,
//       totalSpent: 6335.7,
//       avatar: null,
//       phone: "+12832880796",
//       address: "0702 Kathy Knoll Apt. 962, New Zacharymouth, IA 11017",
//       isBlocked: true,
//     },
//     {
//       id: 56,
//       name: "Christopher Jones",
//       email: "stewartsean@yahoo.com",
//       role: "manager",
//       status: "inactive",
//       createdAt: "2025-03-02T23:41:32Z",
//       lastLogin: "2025-03-22T23:41:32Z",
//       totalTransactions: 43,
//       totalSpent: 2228.08,
//       avatar: null,
//       phone: "+11955544890",
//       address: "2956 Parks Valleys, East Drew, VA 55834",
//       isBlocked: false,
//     },
//     {
//       id: 57,
//       name: "Matthew Rasmussen",
//       email: "ohumphrey@forbes-boyd.org",
//       role: "manager",
//       status: "inactive",
//       createdAt: "2024-10-23T00:49:47Z",
//       lastLogin: "2024-11-20T00:49:47Z",
//       totalTransactions: 17,
//       totalSpent: 5512.78,
//       avatar: null,
//       phone: "+11584999618",
//       address: "253 Kristina Center, Lake Christinaland, OH 60410",
//       isBlocked: false,
//     },
//     {
//       id: 58,
//       name: "Mark Bush",
//       email: "vanessalee@yahoo.com",
//       role: "user",
//       status: "inactive",
//       createdAt: "2025-05-14T14:16:22Z",
//       lastLogin: "2025-05-23T14:16:22Z",
//       totalTransactions: 36,
//       totalSpent: 7187.42,
//       avatar: null,
//       phone: "+14339810819",
//       address: "061 Heather Wall Suite 429, West Randy, MN 87760",
//       isBlocked: false,
//     },
//     {
//       id: 59,
//       name: "Mr. Edward Smith",
//       email: "bowenmatthew@smith-smith.biz",
//       role: "manager",
//       status: "inactive",
//       createdAt: "2024-10-26T08:01:44Z",
//       lastLogin: "2024-10-28T08:01:44Z",
//       totalTransactions: 47,
//       totalSpent: 6467.23,
//       avatar: null,
//       phone: "+16861500470",
//       address: "12799 Palmer Glens Suite 854, Camposmouth, MT 12732",
//       isBlocked: true,
//     },
//     {
//       id: 60,
//       name: "Robert Adams",
//       email: "martinezjamie@yahoo.com",
//       role: "manager",
//       status: "active",
//       createdAt: "2025-03-05T06:38:30Z",
//       lastLogin: "2025-03-17T06:38:30Z",
//       totalTransactions: 13,
//       totalSpent: 3922.81,
//       avatar: null,
//       phone: "+12395120312",
//       address: "7918 Jones Road Apt. 081, South Michael, MT 48274",
//       isBlocked: false,
//     },
//     {
//       id: 61,
//       name: "Tamara Sanders",
//       email: "hbray@johnson-mullen.com",
//       role: "admin",
//       status: "inactive",
//       createdAt: "2025-04-06T05:27:25Z",
//       lastLogin: "2025-04-25T05:27:25Z",
//       totalTransactions: 31,
//       totalSpent: 3363.1,
//       avatar: null,
//       phone: "+15959345032",
//       address: "886 Kimberly Turnpike, East Kent, DE 87994",
//       isBlocked: false,
//     },
//     {
//       id: 62,
//       name: "Steven Nixon",
//       email: "davenportsharon@gmail.com",
//       role: "user",
//       status: "active",
//       createdAt: "2025-02-14T06:18:08Z",
//       lastLogin: "2025-03-02T06:18:08Z",
//       totalTransactions: 47,
//       totalSpent: 9049.42,
//       avatar: null,
//       phone: "+18501124973",
//       address: "Unit 8929 Box 8606, DPO AP 09170",
//       isBlocked: true,
//     },
//     {
//       id: 63,
//       name: "Mark Pham",
//       email: "rachel69@martinez-gibson.com",
//       role: "user",
//       status: "inactive",
//       createdAt: "2025-07-30T03:25:00Z",
//       lastLogin: "2025-08-27T03:25:00Z",
//       totalTransactions: 47,
//       totalSpent: 2256.11,
//       avatar: null,
//       phone: "+14855711628",
//       address: "846 Barton Throughway Apt. 220, Cantumouth, WV 10022",
//       isBlocked: true,
//     },
//     {
//       id: 64,
//       name: "Debra Galvan",
//       email: "natashaallen@cunningham-martinez.net",
//       role: "manager",
//       status: "active",
//       createdAt: "2024-10-11T18:49:19Z",
//       lastLogin: "2024-10-16T18:49:19Z",
//       totalTransactions: 4,
//       totalSpent: 7629.12,
//       avatar: null,
//       phone: "+16341633764",
//       address: "975 Thomas River Suite 550, Louisborough, PA 99204",
//       isBlocked: true,
//     },
//     {
//       id: 65,
//       name: "Steven Chavez",
//       email: "banderson@hotmail.com",
//       role: "admin",
//       status: "inactive",
//       createdAt: "2025-01-11T17:27:35Z",
//       lastLogin: "2025-01-31T17:27:35Z",
//       totalTransactions: 46,
//       totalSpent: 6606.3,
//       avatar: null,
//       phone: "+19460494950",
//       address: "8993 Thomas Track, Valdezmouth, IN 89168",
//       isBlocked: true,
//     },
//     {
//       id: 66,
//       name: "Brian Farmer",
//       email: "ywalker@parker.biz",
//       role: "admin",
//       status: "active",
//       createdAt: "2024-12-01T07:33:01Z",
//       lastLogin: "2024-12-26T07:33:01Z",
//       totalTransactions: 32,
//       totalSpent: 7557.36,
//       avatar: null,
//       phone: "+17674387889",
//       address: "50321 Fowler Vista Suite 199, Wattsfurt, VT 34991",
//       isBlocked: false,
//     },
//     {
//       id: 67,
//       name: "Nathan Montgomery",
//       email: "brandon31@gmail.com",
//       role: "manager",
//       status: "active",
//       createdAt: "2025-06-02T20:23:01Z",
//       lastLogin: "2025-07-02T20:23:01Z",
//       totalTransactions: 30,
//       totalSpent: 5428.39,
//       avatar: null,
//       phone: "+13627967192",
//       address: "1426 Mejia Camp Apt. 368, Jameschester, MS 50142",
//       isBlocked: false,
//     },
//     {
//       id: 68,
//       name: "Jacqueline Santos",
//       email: "sandy62@hotmail.com",
//       role: "admin",
//       status: "active",
//       createdAt: "2024-12-28T15:56:20Z",
//       lastLogin: "2025-01-15T15:56:20Z",
//       totalTransactions: 25,
//       totalSpent: 5206.7,
//       avatar: null,
//       phone: "+15660802959",
//       address: "0484 Thomas Ferry, East Gabrielle, WY 09220",
//       isBlocked: false,
//     },
//     {
//       id: 69,
//       name: "Raymond Fischer",
//       email: "hdavis@howard.com",
//       role: "user",
//       status: "inactive",
//       createdAt: "2025-05-03T07:47:32Z",
//       lastLogin: "2025-05-30T07:47:32Z",
//       totalTransactions: 6,
//       totalSpent: 2003.56,
//       avatar: null,
//       phone: "+16167998592",
//       address: "55072 Clark Plaza Apt. 335, South Peggy, RI 24841",
//       isBlocked: false,
//     },
//     {
//       id: 70,
//       name: "John Benson",
//       email: "calderondaniel@gmail.com",
//       role: "admin",
//       status: "inactive",
//       createdAt: "2024-09-26T11:18:07Z",
//       lastLogin: "2024-09-27T11:18:07Z",
//       totalTransactions: 8,
//       totalSpent: 3217.77,
//       avatar: null,
//       phone: "+12312768327",
//       address: "Unit 3939 Box 6123, DPO AE 15699",
//       isBlocked: false,
//     },
//     {
//       id: 71,
//       name: "Jonathan Simmons",
//       email: "shelly39@gmail.com",
//       role: "user",
//       status: "inactive",
//       createdAt: "2024-10-31T20:35:49Z",
//       lastLogin: "2024-11-10T20:35:49Z",
//       totalTransactions: 29,
//       totalSpent: 2894.82,
//       avatar: null,
//       phone: "+18903050396",
//       address: "07525 Rogers Loaf, West Stephanietown, OH 58941",
//       isBlocked: true,
//     },
//     {
//       id: 72,
//       name: "Michelle Nelson",
//       email: "matthew16@thompson.com",
//       role: "admin",
//       status: "inactive",
//       createdAt: "2025-02-13T14:41:17Z",
//       lastLogin: "2025-02-15T14:41:17Z",
//       totalTransactions: 47,
//       totalSpent: 5942.37,
//       avatar: null,
//       phone: "+15984357720",
//       address: "66527 Bates Ports Apt. 159, Hallside, SC 05704",
//       isBlocked: false,
//     },
//     {
//       id: 73,
//       name: "Christopher Thompson",
//       email: "corycooper@soto-stanton.com",
//       role: "admin",
//       status: "inactive",
//       createdAt: "2025-06-23T02:20:21Z",
//       lastLogin: "2025-07-10T02:20:21Z",
//       totalTransactions: 19,
//       totalSpent: 9285.46,
//       avatar: null,
//       phone: "+14340363405",
//       address: "904 Anthony Viaduct, West Dorothymouth, ND 14960",
//       isBlocked: false,
//     },
//     {
//       id: 74,
//       name: "Donald Pruitt",
//       email: "kelleybarbara@yahoo.com",
//       role: "user",
//       status: "inactive",
//       createdAt: "2025-06-19T18:10:46Z",
//       lastLogin: "2025-06-26T18:10:46Z",
//       totalTransactions: 32,
//       totalSpent: 7281.71,
//       avatar: null,
//       phone: "+19615261126",
//       address: "44553 Mendoza Isle, South Gabriel, NH 29362",
//       isBlocked: false,
//     },
//     {
//       id: 75,
//       name: "Kim Marshall",
//       email: "shannondaniels@west.com",
//       role: "user",
//       status: "inactive",
//       createdAt: "2024-12-29T13:17:48Z",
//       lastLogin: "2024-12-31T13:17:48Z",
//       totalTransactions: 50,
//       totalSpent: 4422.23,
//       avatar: null,
//       phone: "+12335940981",
//       address: "667 Michael Parks Suite 219, Herringhaven, MS 01423",
//       isBlocked: false,
//     },
//     {
//       id: 76,
//       name: "David Hartman",
//       email: "ggregory@gmail.com",
//       role: "user",
//       status: "inactive",
//       createdAt: "2024-10-23T19:40:09Z",
//       lastLogin: "2024-11-15T19:40:09Z",
//       totalTransactions: 8,
//       totalSpent: 9440.95,
//       avatar: null,
//       phone: "+19267965212",
//       address: "14425 Patricia Garden Suite 941, North Derek, KS 33681",
//       isBlocked: false,
//     },
//     {
//       id: 77,
//       name: "Sarah Khan",
//       email: "kcosta@buchanan.biz",
//       role: "admin",
//       status: "active",
//       createdAt: "2025-06-18T22:38:28Z",
//       lastLogin: "2025-07-01T22:38:28Z",
//       totalTransactions: 22,
//       totalSpent: 5088.03,
//       avatar: null,
//       phone: "+18208029940",
//       address: "702 Michael Heights, South Kevinside, MN 13003",
//       isBlocked: true,
//     },
//     {
//       id: 78,
//       name: "Jonathan Fox",
//       email: "fhawkins@castillo.com",
//       role: "manager",
//       status: "active",
//       createdAt: "2025-05-30T17:08:38Z",
//       lastLogin: "2025-06-24T17:08:38Z",
//       totalTransactions: 50,
//       totalSpent: 7675.62,
//       avatar: null,
//       phone: "+15153858857",
//       address: "03631 Melinda Mount Suite 305, Williamstown, NE 94980",
//       isBlocked: false,
//     },
//     {
//       id: 79,
//       name: "Don Santana",
//       email: "michael59@garrett.com",
//       role: "user",
//       status: "active",
//       createdAt: "2025-03-13T02:25:11Z",
//       lastLogin: "2025-03-20T02:25:11Z",
//       totalTransactions: 27,
//       totalSpent: 615.63,
//       avatar: null,
//       phone: "+11870598722",
//       address: "779 Johnson Mountains Suite 553, Sarahfurt, ID 68942",
//       isBlocked: true,
//     },
//     {
//       id: 80,
//       name: "Mrs. Michele Melendez",
//       email: "paul28@hotmail.com",
//       role: "user",
//       status: "inactive",
//       createdAt: "2025-06-18T05:54:43Z",
//       lastLogin: "2025-06-26T05:54:43Z",
//       totalTransactions: 37,
//       totalSpent: 4537.15,
//       avatar: null,
//       phone: "+12885812757",
//       address: "5968 Davis Underpass, Charlesside, CO 48880",
//       isBlocked: false,
//     },
//     {
//       id: 81,
//       name: "John Norris",
//       email: "vjohnson@yahoo.com",
//       role: "user",
//       status: "active",
//       createdAt: "2024-12-08T00:31:17Z",
//       lastLogin: "2025-01-07T00:31:17Z",
//       totalTransactions: 24,
//       totalSpent: 6494.33,
//       avatar: null,
//       phone: "+15408816137",
//       address: "4306 Loretta Road Apt. 650, Colemanview, GA 10985",
//       isBlocked: false,
//     },
//     {
//       id: 82,
//       name: "Michelle Cox",
//       email: "lisacollins@gmail.com",
//       role: "manager",
//       status: "inactive",
//       createdAt: "2024-12-18T21:57:12Z",
//       lastLogin: "2025-01-06T21:57:12Z",
//       totalTransactions: 33,
//       totalSpent: 682.67,
//       avatar: null,
//       phone: "+17304194855",
//       address: "2739 Brandi Mountain, Lake Justinmouth, WV 44526",
//       isBlocked: true,
//     },
//     {
//       id: 83,
//       name: "Michael Thompson",
//       email: "jonathanjohnson@harrison.info",
//       role: "admin",
//       status: "active",
//       createdAt: "2025-05-31T16:44:30Z",
//       lastLogin: "2025-06-18T16:44:30Z",
//       totalTransactions: 22,
//       totalSpent: 4314.7,
//       avatar: null,
//       phone: "+15409144712",
//       address: "220 Martin Falls Apt. 132, Stonefort, HI 78618",
//       isBlocked: true,
//     },
//     {
//       id: 84,
//       name: "Randall Moore",
//       email: "paul81@gmail.com",
//       role: "manager",
//       status: "active",
//       createdAt: "2025-07-30T02:40:31Z",
//       lastLogin: "2025-08-10T02:40:31Z",
//       totalTransactions: 5,
//       totalSpent: 323.4,
//       avatar: null,
//       phone: "+17374320231",
//       address: "38673 Walsh Place, Lake Susanview, DE 64917",
//       isBlocked: true,
//     },
//     {
//       id: 85,
//       name: "Roberto Lopez",
//       email: "andrew89@yahoo.com",
//       role: "user",
//       status: "active",
//       createdAt: "2025-08-01T07:17:59Z",
//       lastLogin: "2025-08-19T07:17:59Z",
//       totalTransactions: 23,
//       totalSpent: 6321.78,
//       avatar: null,
//       phone: "+13223906732",
//       address: "70564 Harmon Shore, Ashleyborough, NM 34803",
//       isBlocked: true,
//     },
//     {
//       id: 86,
//       name: "Tamara Blankenship",
//       email: "nroberts@alvarado.info",
//       role: "user",
//       status: "active",
//       createdAt: "2024-10-03T15:08:38Z",
//       lastLogin: "2024-11-01T15:08:38Z",
//       totalTransactions: 3,
//       totalSpent: 5446.94,
//       avatar: null,
//       phone: "+12546296516",
//       address: "4518 Bell Springs Suite 854, Tiffanybury, AR 93224",
//       isBlocked: true,
//     },
//     {
//       id: 87,
//       name: "Anne Williams",
//       email: "lisasolis@gmail.com",
//       role: "admin",
//       status: "active",
//       createdAt: "2025-01-29T10:17:17Z",
//       lastLogin: "2025-02-09T10:17:17Z",
//       totalTransactions: 49,
//       totalSpent: 8661.42,
//       avatar: null,
//       phone: "+15758111419",
//       address: "3387 Vasquez Drives Apt. 249, Jessicabury, MS 11683",
//       isBlocked: true,
//     },
//     {
//       id: 88,
//       name: "Jessica Briggs",
//       email: "sullivanjohn@gmail.com",
//       role: "admin",
//       status: "active",
//       createdAt: "2025-07-23T11:41:47Z",
//       lastLogin: "2025-08-22T11:41:47Z",
//       totalTransactions: 6,
//       totalSpent: 6102.15,
//       avatar: null,
//       phone: "+17180928917",
//       address: "30978 Jacob Run, East Michael, ND 49817",
//       isBlocked: true,
//     },
//     {
//       id: 89,
//       name: "Amy Evans",
//       email: "boltonjasmine@walter.org",
//       role: "admin",
//       status: "inactive",
//       createdAt: "2024-09-23T13:07:29Z",
//       lastLogin: "2024-10-04T13:07:29Z",
//       totalTransactions: 39,
//       totalSpent: 6496.33,
//       avatar: null,
//       phone: "+18510805467",
//       address: "47235 Holder Flat Apt. 030, Johnton, ND 70655",
//       isBlocked: true,
//     },
//     {
//       id: 90,
//       name: "Michael Johnson",
//       email: "rjones@williams-perez.biz",
//       role: "admin",
//       status: "inactive",
//       createdAt: "2024-09-01T08:10:00Z",
//       lastLogin: "2024-09-08T08:10:00Z",
//       totalTransactions: 16,
//       totalSpent: 8301.58,
//       avatar: null,
//       phone: "+18064182404",
//       address: "387 Robertson Pass Apt. 478, Port Randy, KS 14208",
//       isBlocked: false,
//     },
//     {
//       id: 91,
//       name: "Debbie Leach",
//       email: "baileyjulie@gmail.com",
//       role: "user",
//       status: "active",
//       createdAt: "2024-11-25T11:27:22Z",
//       lastLogin: "2024-12-06T11:27:22Z",
//       totalTransactions: 20,
//       totalSpent: 1091.12,
//       avatar: null,
//       phone: "+17987939336",
//       address: "2162 Shari Ford, Hughesville, FL 03836",
//       isBlocked: true,
//     },
//     {
//       id: 92,
//       name: "Patricia Clayton",
//       email: "wayne62@ball.com",
//       role: "admin",
//       status: "active",
//       createdAt: "2024-08-21T14:54:24Z",
//       lastLogin: "2024-09-10T14:54:24Z",
//       totalTransactions: 30,
//       totalSpent: 6851.09,
//       avatar: null,
//       phone: "+14785200693",
//       address: "161 Armstrong Estates Apt. 625, Josephland, WY 84354",
//       isBlocked: false,
//     },
//     {
//       id: 93,
//       name: "Angelica Ayala",
//       email: "calvinwarner@yahoo.com",
//       role: "manager",
//       status: "active",
//       createdAt: "2025-02-05T19:20:18Z",
//       lastLogin: "2025-02-20T19:20:18Z",
//       totalTransactions: 34,
//       totalSpent: 3136.89,
//       avatar: null,
//       phone: "+17995147655",
//       address: "039 John Wall, Lake Shirleyport, LA 22517",
//       isBlocked: true,
//     },
//     {
//       id: 94,
//       name: "Brittany Chavez",
//       email: "anabrown@long-smith.com",
//       role: "admin",
//       status: "active",
//       createdAt: "2025-03-20T18:34:30Z",
//       lastLogin: "2025-04-10T18:34:30Z",
//       totalTransactions: 6,
//       totalSpent: 3272.43,
//       avatar: null,
//       phone: "+18557277975",
//       address: "688 George Grove, South Susan, TX 22507",
//       isBlocked: false,
//     },
//     {
//       id: 95,
//       name: "David Young",
//       email: "antonio83@hotmail.com",
//       role: "admin",
//       status: "inactive",
//       createdAt: "2024-12-25T22:32:18Z",
//       lastLogin: "2024-12-31T22:32:18Z",
//       totalTransactions: 16,
//       totalSpent: 9220.08,
//       avatar: null,
//       phone: "+14796464187",
//       address: "3240 Bishop Club, North Brandonberg, DE 19394",
//       isBlocked: true,
//     },
//     {
//       id: 96,
//       name: "Christopher Kaiser",
//       email: "wguzman@shelton.com",
//       role: "manager",
//       status: "inactive",
//       createdAt: "2025-07-09T00:34:19Z",
//       lastLogin: "2025-07-18T00:34:19Z",
//       totalTransactions: 27,
//       totalSpent: 9601.42,
//       avatar: null,
//       phone: "+17232353566",
//       address: "3922 Goodman Courts Suite 167, Margaretchester, WA 51291",
//       isBlocked: false,
//     },
//     {
//       id: 97,
//       name: "Thomas Woodward",
//       email: "colleenibarra@gmail.com",
//       role: "admin",
//       status: "active",
//       createdAt: "2025-01-05T22:18:23Z",
//       lastLogin: "2025-01-27T22:18:23Z",
//       totalTransactions: 30,
//       totalSpent: 8115.14,
//       avatar: null,
//       phone: "+15144076762",
//       address: "399 Martin Forges, West Jenna, MI 89677",
//       isBlocked: false,
//     },
//     {
//       id: 98,
//       name: "Michael Durham",
//       email: "moyerjoseph@hotmail.com",
//       role: "admin",
//       status: "active",
//       createdAt: "2024-10-07T04:24:54Z",
//       lastLogin: "2024-11-03T04:24:54Z",
//       totalTransactions: 33,
//       totalSpent: 2280.1,
//       avatar: null,
//       phone: "+18483001257",
//       address: "758 Susan Forges, Bradleyfurt, AR 51984",
//       isBlocked: false,
//     },
//     {
//       id: 99,
//       name: "Adam Johnson",
//       email: "baileybrianna@yahoo.com",
//       role: "manager",
//       status: "active",
//       createdAt: "2025-05-12T16:09:42Z",
//       lastLogin: "2025-06-01T16:09:42Z",
//       totalTransactions: 22,
//       totalSpent: 6847.83,
//       avatar: null,
//       phone: "+16805088331",
//       address: "0185 Rebecca Camp, Port Charles, TX 51291",
//       isBlocked: true,
//     },
//     {
//       id: 100,
//       name: "Edward Vaughan",
//       email: "michaeltran@hicks-joseph.biz",
//       role: "manager",
//       status: "active",
//       createdAt: "2025-01-28T09:48:18Z",
//       lastLogin: "2025-01-31T09:48:18Z",
//       totalTransactions: 0,
//       totalSpent: 5734.28,
//       avatar: null,
//       phone: "+12587571065",
//       address: "77829 Herrera Terrace Apt. 683, New Amber, IL 18033",
//       isBlocked: true,
//     },
//   ];

//   const getAllUsers = async () => {
//     setLoading(true);
//     try {
//       await new Promise((resolve) => setTimeout(resolve, 1000));
//       setUsers(dummyData);
//     } catch (error) {
//       handleError(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     getAllUsers();
//   }, [filters, search, limit]);

//   return {
//     totalData: dummyData.length,
//     totalPages: dummyData.length / limit,
//     users,
//     loading,
//     getAllUsers,
//   };
// };

// export default useGetAllUsers;


import { useEffect, useState } from "react";
import axios from "axios";
import { handleError } from "../../utils/helpers";
import { API_CONFIG } from "../../config/constants";

const useGetAllUsers = (filters, page, limit, search) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    total: 0,
    totalPages: 1,
  });

  const getAllUsers = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("authToken");

      const headers = {
        ...API_CONFIG.headers,
        Authorization: token ? `Bearer ${token}` : "",
      };

      const response = await axios.get(`${API_CONFIG.baseURL}/user/all`, {
        params: {
          // ...filters,
          // search,
          page,
          limit,
        },
        headers,
      });

      if (response.status === 200 && response.data.status) {
        const { users, total, totalPages } = response.data.data;
        setUsers(users);
        setPagination({ total, totalPages });
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  // Refetch whenever page, limit, filters, or search changes
  useEffect(() => {
    getAllUsers();
  }, [filters, search, page, limit]);

  return {
    users,
    loading,
    totalData: pagination.total,
    totalPages: pagination.totalPages,
    getAllUsers,
  };
};

export default useGetAllUsers;




